import type { MangoQuery } from "rxdb"
import type { AccountInsulin } from "src/types"

const defaultSelector = {}

// adds "is_deleted" and "account_id" selector to account insulin query
export function createAccountInsulinQueryObject(
  accountId: number,
  {
    selector,
    sort,
    limit,
  }: MangoQuery<AccountInsulin>,
): MangoQuery<AccountInsulin> {
  return {
    selector: {
      account_id: { $eq: accountId },
      ...(selector ?? defaultSelector),
      $or: (selector?.$or ?? []).concat([
        { is_deleted: { $eq: false } },
        { is_deleted: { $exists: false } },
      ]),
    },
    sort,
    limit,
  }
}
